// extracted by mini-css-extract-plugin
export default {"wrapper":"LanguageSwitcher_wrapper__JEWCJ","link":"LanguageSwitcher_link__OCR2a","active":"LanguageSwitcher_active__oWNwG"};